import {
    PackageProduct,
    PackageProductItem,
    PackageProductItemResponse,
    PackageProductResponse,
    PackageItemType,
    DateComponent
} from "../../model";

export const productTypeIdToKey: Record<number, PackageItemType> = {
    1: 'Course',
    2: 'Accommodation',
    3: 'AddOn',
    4: 'Transfer',
    6: 'Fees'
};

export const productTypeKeyToId: Record<PackageItemType, number> = {
    Course: 1,
    Accommodation: 2,
    AddOn: 3,
    Transfer: 4,
    Fees: 6,
};

export function mapPackageProduct(response: PackageProductResponse): PackageProduct {
    const lastModifiedDate = response.lastModifiedOn
        ? new Date(response.lastModifiedOn)
        : undefined;

    const active = typeof response.active === 'boolean' ? response.active : true;
    
    return {
        id: response.id,
        name: response.name,
        description: response.description,
        commissionPercentage: response.commissionPercentage,
        minimumAge: response.minimumAge ?? null,
        maximumAge: response.maximumAge ?? null,
        minimumWeeks: response.minimumWeeks ?? null,
        accountCategoryId: response.accountCategoryId ?? null,
        productCategoryId: response.productCategoryId ?? null,
        items: (response.packageBreakdowns ?? []).map(mapPackageProductItem),
        division: response.divisionId,
        divisionText: undefined,
        entityUpdate: Boolean(response.entityUpdate),
        active,
        lastModifiedDate: lastModifiedDate,
        lastUpdatedBy: response.lastModifiedBy ?? undefined
    };
}

export function mapPackageProductItem(item: PackageProductItemResponse): PackageProductItem {
    const productType = productTypeIdToKey[item.productTypeId] ?? '';

    return {
        productId: item.productId,
        productTypeId: item.productTypeId,
        productType,
        productName: '',
        percentageBreakdown: Number((item.percentageBreakdown ?? 0).toFixed(1)),
    };
}

function mapApiDate(value?: DateComponent | string | null): Date | null | undefined {
    if (!value) {
        return null;
    }

    if (value instanceof Date) {
        return value;
    }

    if (typeof value === 'string') {
        const date = new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    }

    const year = value.year ?? 0;
    const month = (value.month ?? 1) - 1;
    const day = value.day ?? 1;
    const newDate = new Date(year, month, day);
    return Number.isNaN(newDate.getTime()) ? null : newDate;
}